// Generated by /app/scripts/build_api_catalogue.py from the supplied product spreadsheet. Do not edit by hand.
// Manufacturer names are intentionally excluded.
export const DOC_TYPES = ["USDMF", "EDMF", "KDMF", "DMF"];

export const apiCatalogue = [
 {
  "name": "Abacavir Base",
  "category": "Anti-infective",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Abacavir Sulphate",
  "category": "Antiretrovirals",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Abemaciclib",
  "category": "Breast cancer",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Abiraterone Acetate",
  "category": "Oncology, Antineoplastics",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Acalabrutinib",
  "category": "Non-Hodgkin's lymphoma",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Aclidinium Bromide",
  "category": "COPD",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Acyclovir",
  "category": "Herpes virus",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Adapalene",
  "category": "Anti-acne",
  "docs": [
   "USDMF",
   "EDMF",
   "KDMF"
  ]
 },
 {
  "name": "Adefovir Dipivoxil",
  "category": "Hepatitis B",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Afatinib",
  "category": "Antineoplastic, Non-small cell lung cancer",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Agomelatine",
  "category": "Antidepressant",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Albendazole",
  "category": "Anti-helminthic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Alcaftadine",
  "category": "Conjunctivitis",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Alectinib HCl",
  "category": "Antineoplastics, Non-small cell lung cancer",
  "docs": [
   "USDMF",
   "DMF"
  ]
 },
 {
  "name": "Alendronate Sodium",
  "category": "Osteoporosis",
  "docs": [
   "EDMF",
   "KDMF"
  ]
 },
 {
  "name": "Alfuzosin HCl",
  "category": "Urology, Benign prostatic hyperplasia",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Aliskiren Hemifumarate",
  "category": "Antihypertensive",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Almotriptan Maleate",
  "category": "Anti-migraine",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Alogliptin",
  "category": "Diabetes, Antidiabetic",
  "docs": [
   "USDMF",
   "KDMF",
   "DMF"
  ]
 },
 {
  "name": "Alogliptin Benzoate",
  "category": "Antidiabetic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Alogliptin Benzoate Form A",
  "category": "Diabetes",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Alvimopan",
  "category": "Post-operative ileus",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Ambrisentan",
  "category": "Pulmonary hypertension",
  "docs": [
   "USDMF",
   "DMF"
  ]
 },
 {
  "name": "Aminocaproic Acid",
  "category": "Periodontal disease",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Amiodarone HCl",
  "category": "Anti-arrhythmic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Amlodipine Besylate",
  "category": "Cardiovascular",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Amorolfine HCl",
  "category": "",
  "docs": []
 },
 {
  "name": "Anastrozole",
  "category": "Antineoplastics",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Apalutamide",
  "category": "Prostate cancer",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Apixaban",
  "category": "",
  "docs": []
 },
 {
  "name": "Aprepitant",
  "category": "",
  "docs": []
 },
 {
  "name": "Atomoxetine HCl",
  "category": "ADHD",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Atomoxetine Hydrochloride",
  "category": "CNS",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Atorvastatin Calcium",
  "category": "Cardiovascular, Hyperlipidaemia",
  "docs": [
   "USDMF",
   "EDMF",
   "KDMF"
  ],
  "note": "Amorphous & crystalline"
 },
 {
  "name": "Atorvastatin Calcium (Amorphous, Form-1)",
  "category": "Antihyperlipidaemic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Atorvastatin Calcium Trihydrate",
  "category": "Hyperlipidaemia",
  "docs": [
   "KDMF",
   "DMF"
  ]
 },
 {
  "name": "Atorvastatin Calcium Trihydrate Form I",
  "category": "Hyperlipidaemia",
  "docs": [
   "KDMF",
   "DMF"
  ]
 },
 {
  "name": "Atovaquone",
  "category": "Antiparasitic",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Avanafil",
  "category": "Erectile dysfunction",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Avatrombopag Maleate",
  "category": "Thrombocytopenia",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Axitinib",
  "category": "Kidney cancer, Antineoplastic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Axitinib Form IV",
  "category": "Antineoplastics",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Azacitidine",
  "category": "Oncology, Antineoplastic",
  "docs": [
   "USDMF",
   "EDMF",
   "KDMF"
  ]
 },
 {
  "name": "Azelaic Acid",
  "category": "Anti-acne",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Azelastine",
  "category": "Antihistaminic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Azelnidipine",
  "category": "Antihypertensive",
  "docs": [],
  "note": "Lab development"
 },
 {
  "name": "Azilsartan",
  "category": "Antihypertensive",
  "docs": []
 },
 {
  "name": "Azilsartan (Base)",
  "category": "Antihypertensive",
  "docs": []
 },
 {
  "name": "Azilsartan Kamedoxomil Form I",
  "category": "ARBs",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Azilsartan Medoxomil",
  "category": "Antihypertensive",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Azilsartan Medoxomil Monopotassium",
  "category": "Antihypertensive",
  "docs": [
   "EDMF"
  ]
 },
 {
  "name": "Azithromycin Dihydrate",
  "category": "Anti-infective (macrolides)",
  "docs": [
   "USDMF",
   "KDMF",
   "DMF"
  ]
 },
 {
  "name": "Azithromycin Dihydrate (ADF Process)",
  "category": "Anti-infective (macrolides)",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Azithromycin Dihydrate (AZP Process)",
  "category": "Anti-infective (macrolides)",
  "docs": []
 },
 {
  "name": "Azithromycin Monohydrate",
  "category": "Anti-infective (macrolides)",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Azithromycin Monohydrate (AHM Process)",
  "category": "Anti-infective (macrolides)",
  "docs": []
 },
 {
  "name": "Azithromycin Monohydrate Isopropanol Clathrate",
  "category": "Anti-infective (macrolides)",
  "docs": []
 },
 {
  "name": "Bazedoxifene",
  "category": "Anti-osteoporosis",
  "docs": [
   "KDMF"
  ]
 },
 {
  "name": "Bazedoxifene Acetate",
  "category": "Osteoporosis",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Bedaquiline",
  "category": "Anti-tuberculosis",
  "docs": [
   "USDMF"
  ],
  "note": "Lab development"
 },
 {
  "name": "Brivaracetam",
  "category": "",
  "docs": []
 },
 {
  "name": "Buclizine HCl",
  "category": "",
  "docs": []
 },
 {
  "name": "Calcium Dobesilate",
  "category": "",
  "docs": []
 },
 {
  "name": "Camylofine DiHCl",
  "category": "",
  "docs": []
 },
 {
  "name": "Carbocisteine",
  "category": "",
  "docs": []
 },
 {
  "name": "Carboplatin",
  "category": "",
  "docs": []
 },
 {
  "name": "Carvedilol",
  "category": "",
  "docs": []
 },
 {
  "name": "Cefditoren Pivoxil",
  "category": "",
  "docs": []
 },
 {
  "name": "Cefixime Trihydrate",
  "category": "",
  "docs": []
 },
 {
  "name": "Cefpodoxime Proxetil",
  "category": "",
  "docs": []
 },
 {
  "name": "Ceftazidime + Avibactam",
  "category": "",
  "docs": []
 },
 {
  "name": "Cefuroxime Axetil",
  "category": "",
  "docs": []
 },
 {
  "name": "Cilnidipine",
  "category": "",
  "docs": []
 },
 {
  "name": "Cinitapride Hydrogen Tartrate",
  "category": "",
  "docs": []
 },
 {
  "name": "Cisplatin",
  "category": "",
  "docs": []
 },
 {
  "name": "Citicoline Sodium (Oral/Sterile)",
  "category": "",
  "docs": []
 },
 {
  "name": "Clomipramine HCl",
  "category": "",
  "docs": []
 },
 {
  "name": "Cyclophosphamide (Oral/Sterile)",
  "category": "",
  "docs": []
 },
 {
  "name": "Dextromethorphan HBr",
  "category": "",
  "docs": []
 },
 {
  "name": "Dorzolamide HCl",
  "category": "",
  "docs": []
 },
 {
  "name": "Dothiepin HCl",
  "category": "",
  "docs": []
 },
 {
  "name": "Doxapram HCl",
  "category": "",
  "docs": []
 },
 {
  "name": "Doxophylline HCl",
  "category": "",
  "docs": []
 },
 {
  "name": "Duloxetine HCl",
  "category": "",
  "docs": []
 },
 {
  "name": "Dydrogesterone",
  "category": "",
  "docs": []
 },
 {
  "name": "Empagliflozin",
  "category": "Antidiabetic",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Empagliflozin Amorphous (Honour)",
  "category": "Diabetes",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Emtricitabine",
  "category": "Antiretrovirals",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Enalapril Maleate",
  "category": "Cardiovascular",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Entacapone Form A",
  "category": "Parkinson's",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Entecavir",
  "category": "Antiviral",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Entecavir Monohydrate",
  "category": "Hepatitis B",
  "docs": [
   "KDMF"
  ]
 },
 {
  "name": "Enzalutamide",
  "category": "Prostate cancer, Antineoplastics",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Eplerenone",
  "category": "Antihypertensive",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Epoprostenol Sodium",
  "category": "Pulmonary hypertension",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Eprosartan Mesylate",
  "category": "ARBs",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Erlotinib HCl (Form A)",
  "category": "Antineoplastic agent",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Erlotinib HCl (Form B)",
  "category": "Antineoplastic agent",
  "docs": [
   "KDMF"
  ]
 },
 {
  "name": "Erlotinib HCl Form A / Form B",
  "category": "Antineoplastics",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Erlotinib Hydrochloride",
  "category": "Non-small cell lung cancer",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Ertugliflozin",
  "category": "Antidiabetic",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Erythromycin Base",
  "category": "Anti-infective (macrolides)",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Erythromycin Ethyl Succinate",
  "category": "Antibacterial",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Escitalopram Oxalate",
  "category": "",
  "docs": []
 },
 {
  "name": "Granisetron",
  "category": "Oncology",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Hydralazine",
  "category": "Antihypertensive",
  "docs": [],
  "note": "Lab development"
 },
 {
  "name": "Hydralazine HCl",
  "category": "ARBs",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Hydrochlorothiazide",
  "category": "Antihypertensive",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Ibrutinib",
  "category": "Chronic lymphocytic leukemia, Antineoplastics",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Ibrutinib Form-A",
  "category": "Tyrosine kinase inhibitor",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Icatibant",
  "category": "Hereditary angioedema",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Icatibant Acetate",
  "category": "Others",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Iloperidone",
  "category": "Antipsychotic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Imatinib Mesylate Amorphous / alpha-Form / beta-Form",
  "category": "Antineoplastics",
  "docs": [
   "USDMF",
   "EDMF",
   "KDMF"
  ]
 },
 {
  "name": "Imiquimod",
  "category": "Immunomodulator",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Iopamidol",
  "category": "Contrast medium",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Irbesartan",
  "category": "Angiotensin II receptor antagonist, Cardiovascular",
  "docs": [
   "USDMF",
   "KDMF",
   "DMF"
  ]
 },
 {
  "name": "Irinotecan HCl",
  "category": "Antineoplastics",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Iron Sucrose",
  "category": "Hematinic",
  "docs": [],
  "note": "Lab validation"
 },
 {
  "name": "Levomilnacipran Hydrochloride",
  "category": "Antidepressant",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Lifitegrast",
  "category": "Keratoconjunctivitis, Ophthalmologic agent",
  "docs": [
   "USDMF",
   "DMF"
  ]
 },
 {
  "name": "Linaclotide",
  "category": "IBS",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Linagliptin",
  "category": "Antidiabetic",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Linezolid",
  "category": "Anti-infective",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Linezolid USP Form I New Process",
  "category": "Anti-infective",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Lisinopril",
  "category": "ARBs",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Lithium Carbonate",
  "category": "Anti-manic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Lofexidine",
  "category": "Opioid withdrawal symptoms",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Lomitapide Mesylate",
  "category": "Antihyperlipidaemic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Lomustine",
  "category": "Oncology",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Lopinavir Form I & Amorphous",
  "category": "Antiretrovirals",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Losartan Monopotassium",
  "category": "Antihypertensive",
  "docs": [
   "USDMF",
   "KDMF",
   "DMF"
  ]
 },
 {
  "name": "Losartan Potassium",
  "category": "Cardiovascular",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Nebivolol HCl",
  "category": "ARBs",
  "docs": [
   "USDMF",
   "EDMF",
   "KDMF"
  ]
 },
 {
  "name": "Neostigmine Methyl Sulfate",
  "category": "Antagonist",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Neratinib",
  "category": "Breast cancer",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Neratinib Maleate",
  "category": "Antineoplastics",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Netupitant",
  "category": "Antiemetic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Nevirapine Form I",
  "category": "Antiretrovirals",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Nilotinib",
  "category": "Chronic myeloid leukemia",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Nilotinib Hydrochloride",
  "category": "Oncology",
  "docs": [
   "USDMF"
  ],
  "note": "Available for selected markets"
 },
 {
  "name": "Nimodipine",
  "category": "Subarachnoid hemorrhage",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Nintedanib",
  "category": "Ovarian cancer",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Nintedanib Esylate",
  "category": "Antineoplastic & immunomodulator",
  "docs": [
   "USDMF",
   "DMF"
  ]
 },
 {
  "name": "Niraparib Tosylate Monohydrate",
  "category": "Antineoplastics",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Nisoldipine",
  "category": "Antihypertensive",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Nizatidine",
  "category": "Gastrointestinal",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "O-Desmethyl Venlafaxine Base",
  "category": "Antidepressant",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "O-Desmethyl Venlafaxine Succinate",
  "category": "Antidepressant",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Obeticholic Acid",
  "category": "Primary biliary cirrhosis",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Olanzapine",
  "category": "CNS",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Olanzapine Form I",
  "category": "Antipsychotics",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Olaparib",
  "category": "Antineoplastics",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Perampanel",
  "category": "Antiepileptic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Perindopril Arginine",
  "category": "Antihypertensive",
  "docs": [
   "EDMF"
  ]
 },
 {
  "name": "Perindopril Erbumine",
  "category": "Antihypertensive",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Permethrin",
  "category": "Others",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Phytonadione",
  "category": "Vitamin K",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Pimavanserin",
  "category": "Parkinson's",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Pimavanserin Tartrate",
  "category": "Hallucinations & delusions",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Pioglitazone",
  "category": "Antidiabetic",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Pioglitazone HCl",
  "category": "Diabetes",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Pirfenidone",
  "category": "Idiopathic pulmonary fibrosis, Antifibrotic agent",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Pitavastatin Calcium",
  "category": "Antihyperlipidaemic",
  "docs": [
   "USDMF",
   "EDMF",
   "KDMF"
  ]
 },
 {
  "name": "Plerixafor",
  "category": "Oncology, Antineoplastics",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Rivaroxaban",
  "category": "Cardiovascular, Anticoagulant",
  "docs": [
   "USDMF",
   "EDMF",
   "KDMF",
   "DMF"
  ]
 },
 {
  "name": "Rivastigmine",
  "category": "Anti-Alzheimer's",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Rivastigmine Base",
  "category": "Anti-Alzheimer",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Rivastigmine Hydrogen Tartrate",
  "category": "CNS",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Rivastigmine Tartrate",
  "category": "Anti-Alzheimer",
  "docs": [
   "USDMF",
   "KDMF",
   "DMF"
  ]
 },
 {
  "name": "Rizatriptan Benzoate",
  "category": "Anti-migraine",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Roflumilast",
  "category": "Respiratory agent, Bronchodilator",
  "docs": [
   "USDMF",
   "EDMF",
   "KDMF"
  ]
 },
 {
  "name": "Rolapitant",
  "category": "Antiemetic",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Romidepsin",
  "category": "Non-Hodgkin's lymphoma",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Ropinirole HCl",
  "category": "Anti-Parkinsonian",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Rosuvastatin Calcium",
  "category": "Antihyperlipidaemic",
  "docs": [
   "USDMF",
   "EDMF",
   "DMF"
  ]
 },
 {
  "name": "Roxithromycin",
  "category": "Anti-infective (macrolides)",
  "docs": [
   "KDMF"
  ]
 },
 {
  "name": "Rucaparib",
  "category": "Ovarian cancer",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Rucaparib / Rucaparib Camsylate",
  "category": "Antineoplastics",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Rufinamide",
  "category": "Anticonvulsant, Antiepileptic",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Rupatadine Fumarate",
  "category": "Antihistamines",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Ruxolitinib",
  "category": "Myelodysplastic syndromes",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Sacubitril + Valsartan",
  "category": "Antihypertensive, Cardiovascular",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Safinamide",
  "category": "Parkinson's disease",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Safinamide Mesylate",
  "category": "Parkinson's",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Salmeterol Xinafoate",
  "category": "Antiasthmatic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Sapropterin DiHCl",
  "category": "Metabolic agent",
  "docs": [],
  "note": "Lab development"
 },
 {
  "name": "Saquinavir Mesylate",
  "category": "Antiretrovirals",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Saxagliptin",
  "category": "Diabetes",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Saxagliptin HCl MH",
  "category": "Antidiabetic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Saxagliptin Monohydrate",
  "category": "Antidiabetic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Selexipag",
  "category": "Antihypertensive",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Sertaconazole Nitrate",
  "category": "Antifungal",
  "docs": []
 },
 {
  "name": "Sertraline Hydrochloride Form I & Form II",
  "category": "Antidepressants",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Sevelamer Carbonate",
  "category": "Hyperphosphatemia",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Sevelamer HCl",
  "category": "Chronic kidney disease",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Sildenafil Citrate",
  "category": "Erectile dysfunction / PAH",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Solifenacin Succinate",
  "category": "Antispasmodic",
  "docs": [
   "USDMF",
   "KDMF",
   "DMF"
  ]
 },
 {
  "name": "Solriamfetol",
  "category": "Antinarcoleptic",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Sonidegib",
  "category": "Basal cell carcinoma",
  "docs": [
   "USDMF",
   "DMF"
  ]
 },
 {
  "name": "Sonidegib Phosphate",
  "category": "Antineoplastics",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Sorafenib Form-I",
  "category": "Antineoplastic agent",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Sorafenib Form-III",
  "category": "Antineoplastic agent",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Sorafenib Tosylate",
  "category": "Kidney cancer",
  "docs": [
   "USDMF",
   "KDMF"
  ]
 },
 {
  "name": "Sorafenib Tosylate Form III",
  "category": "Angiogenesis inhibitor",
  "docs": [
   "KDMF",
   "DMF"
  ]
 },
 {
  "name": "Sunitinib",
  "category": "Kidney cancer",
  "docs": []
 },
 {
  "name": "Sunitinib Malate",
  "category": "Anticancer",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Sunitinib Malate Form I / Base",
  "category": "Antineoplastics",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Suvorexant",
  "category": "Insomnia, Alzheimer's disease",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Tadalafil",
  "category": "Urologic agent, Erectile dysfunction / PAH",
  "docs": [
   "USDMF",
   "EDMF",
   "KDMF"
  ]
 },
 {
  "name": "Tadalafil Form I",
  "category": "Erectile dysfunction",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Tafamidis",
  "category": "Transthyretin stabilizer, Transthyretin-mediated amyloidosis",
  "docs": [
   "USDMF"
  ],
  "note": "Lab development"
 },
 {
  "name": "Tafenoquine",
  "category": "Antimalarial",
  "docs": []
 },
 {
  "name": "Tafluprost",
  "category": "Glaucoma & ocular hypertension",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Talazoparib Tosylate",
  "category": "Breast cancer",
  "docs": []
 },
 {
  "name": "Tamoxifen Citrate",
  "category": "Antineoplastics",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Tapentadol",
  "category": "Analgesic",
  "docs": []
 },
 {
  "name": "Tasimelteon",
  "category": "Non-24-hour sleep-wake disorder",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Tavaborole",
  "category": "Antifungal",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Teduglutide",
  "category": "Short bowel syndrome",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Telmisartan",
  "category": "Antihypertensive, Cardiovascular",
  "docs": [
   "USDMF",
   "EDMF",
   "KDMF",
   "DMF"
  ]
 },
 {
  "name": "Telotristat Etiprate",
  "category": "Carcinoid syndrome",
  "docs": [
   "DMF"
  ]
 },
 {
  "name": "Temozolomide Form III",
  "category": "Antineoplastics",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Teneligliptin",
  "category": "Antidiabetic",
  "docs": []
 },
 {
  "name": "Tenofovir Alafenamide",
  "category": "Antiretrovirals & HCV",
  "docs": []
 },
 {
  "name": "Tenofovir Alafenamide Fumarate",
  "category": "Hepatitis B",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Tenofovir Alafenamide Hemifumarate",
  "category": "Nucleotide reverse transcriptase inhibitor",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Tenofovir Disoproxil / Alafenamide",
  "category": "Antiretroviral",
  "docs": [
   "USDMF"
  ]
 },
 {
  "name": "Tenofovir Disoproxil Base",
  "category": "Antiretrovirals",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Tenofovir Disoproxil Fumarate",
  "category": "Antiretrovirals",
  "docs": [
   "USDMF",
   "EDMF",
   "KDMF"
  ]
 },
 {
  "name": "Terbinafine HCl",
  "category": "Antifungal",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 },
 {
  "name": "Terbinafine Hydrochloride",
  "category": "Anti-infective, Antifungal",
  "docs": [
   "USDMF",
   "EDMF"
  ]
 }
];
